module.exports = __webpack_public_path__ + "static/ARTS_KAPAK_2-2ac011743a0c25072633c84742a025b7.jpg";